<template>
  <nav class="navbar navbar-fixed-top">
    <div class="container-fluid">
      <div class="navbar-header">
        <button
          type="button"
          class="navbar-toggle"
          data-toggle="collapse"
          data-target="#navbar"
          aria-expanded="false"
          aria-controls="navbar"
        >
          <span class="sr-only">Toggle navigation</span>
          <span class="icon-bar"></span>
          <span class="icon-bar"></span>
          <span class="icon-bar"></span>
        </button>
        <a class="navbar-brand" href="#">
          <img src="/capsiminbox/images/capsim-iap-logo.svg" alt="CapsimInbox Toolkit Logo" />
        </a>
      </div>
      <template v-if="$store.state.isEditMode">
        <edit-mode-nav></edit-mode-nav>
      </template>
      <template v-else>
        <dashboard-nav></dashboard-nav>
      </template>
    </div>
  </nav>
</template>

<script>
  import DashboardNav from './DashboardNav';
  import EditModeNav from './EditModeNav';

  export default {
    components: {
      DashboardNav,
      EditModeNav,
    },
  };
</script>

<style lang="scss" scoped>
  .navbar {
    border: none;
    background-color: #003f54;

    .navbar-brand {
      padding-top: 5px !important;
      padding-bottom: 5px !important;
      img {
        height: 100%;
      }
    }
  }

  @media print {
    .navbar {
      display: none;
    }
  }
</style>
